// extracted by mini-css-extract-plugin
module.exports = {"root":"OrientationVideoPlayer_root__JLadv","loader":"OrientationVideoPlayer_loader__rskuy"};